import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { searchEmployersAction, clearEmployersPredictionsList, getDetailedUser } from '../../../actions/users';
import { clearEmployerDetails } from '../../../actions/employers';
import { getAllSkills, getSkillLevels } from '../../../actions/skills';
import { getLocationsListAction, getCompanyLocations, addUserLocation } from '../../../actions/locations';
import { getEventsAction, createEventAction, editEventAction } from '../../../actions/events';
import { getAllDressCodesAction } from '../../../actions/dressCode';
import { createJobAction, getPayCostRateAction, postToBoardAction, createMultiDayJob } from '../../../actions/jobs';
import { getAllJobCategories } from '../../../actions/jobCategories';
import { addJobWorkerAction } from '../../../actions/jobWorkers';
import { getCompanyLTAWorkers, clearCompanyLTAWorkers, getCompanyDetailsAction, getCompanyFavAndBlocks,
  clearCompanyFavAndBlocks } from '../../../actions/companies';
import { UIShowAlert, UIShowConfirm } from '../../../actions/ui';
import { hideAsideMenu, showAsideMenu } from '../../../actions';
import CreateJob from './createJob';
import CreateJobEmployerSingle from './createJobEmployerSingle';
import { getBasicSkillLevelId } from '../../../helpers/general';
import UsersService from '../../../services/UsersService';

class CreateJobContainer extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    employerDetails: PropTypes.object.isRequired,
    userEventsList: PropTypes.array.isRequired,
    employersPredictionsList: PropTypes.array.isRequired,
    companyDetails: PropTypes.shape({
      ltaWorkers: PropTypes.array.isRequired,
      favAndBlocks: PropTypes.array.isRequired
    }),
    skillsList: PropTypes.array.isRequired,
    skillLevels: PropTypes.array.isRequired,
    locationsList: PropTypes.array.isRequired,
    costPayRateList: PropTypes.array.isRequired,
    costPayRateIsLoading: PropTypes.bool.isRequired,
    dressCodesList: PropTypes.array.isRequired,
    companyLocations: PropTypes.array.isRequired,
    jobCategories: PropTypes.array.isRequired,
    getAllSkills: PropTypes.func.isRequired,
    getSkillLevels: PropTypes.func.isRequired,
    getLocationsListAction: PropTypes.func.isRequired,
    getEventsAction: PropTypes.func.isRequired,
    getAllDressCodesAction: PropTypes.func.isRequired,
    editEventAction: PropTypes.func.isRequired,
    createEventAction: PropTypes.func.isRequired,
    createJobAction: PropTypes.func.isRequired,
    createMultiDayJob: PropTypes.func.isRequired,
    getPayCostRateAction: PropTypes.func.isRequired,
    clearEmployersPredictionsList: PropTypes.func.isRequired,
    getDetailedUser: PropTypes.func.isRequired,
    clearEmployerDetails: PropTypes.func.isRequired,
    getCompanyLocations: PropTypes.func.isRequired,
    getAllJobCategories: PropTypes.func.isRequired,
    addUserLocation: PropTypes.func.isRequired,
    postToBoardAction: PropTypes.func.isRequired,
    getCompanyLTAWorkers: PropTypes.func.isRequired,
    clearCompanyLTAWorkers: PropTypes.func.isRequired,
    getCompanyFavAndBlocks: PropTypes.func.isRequired,
    clearCompanyFavAndBlocks: PropTypes.func.isRequired,
    addJobWorkerAction: PropTypes.func.isRequired,
    showAsideMenu: PropTypes.func.isRequired,
    hideAsideMenu: PropTypes.func.isRequired
  };

  state = {
    basicSkillLevelId: null
  };

  componentDidMount () {
    this.props.getAllJobCategories();
    this.props.getLocationsListAction();
    this.props.getSkillLevels();
    this.props.getAllDressCodesAction();
    if (UsersService.isAdmin()) {
      this.props.hideAsideMenu();
    }
  }

  componentWillUnmount () {
    this.props.clearEmployerDetails();
    if (UsersService.isAdmin()) {
      this.props.showAsideMenu();
    }
  };

  componentDidUpdate (prevProps) {
    if (prevProps.skillLevels !== this.props.skillLevels) {
      this.setBasicSkillLevel();
    }
  }

  setBasicSkillLevel = () => this.setState({
    basicSkillLevelId: getBasicSkillLevelId(this.props.skillLevels)
  });

  _renderContent = props => {
    return UsersService.isAdmin() || props.user.is_lta ? <CreateJob {...props} /> : <CreateJobEmployerSingle {...props} />;
  };

  render () {
    const { basicSkillLevelId } = this.state;
    return this._renderContent({ ...this.props, basicSkillLevelId });
  }
}

const mapStateToProps = state => {
  return {
    user: UsersService.isAdmin() ? state.employers.employerDetails : state.user,
    employerDetails: state.employers.employerDetails, // it's used in CreateJobEmployerSingle
    employersPredictionsList: state.users.employersPredictionsList,
    skillsList: state.skillsList,
    skillLevels: state.skillLevels,
    locationsList: state.locations.locationsList,
    costPayRateList: state.jobs.costPayRateList,
    costPayRateIsLoading: state.jobs.costPayRateIsLoading,
    userEventsList: state.events.userEventsList,
    dressCodesList: state.dressCodesList,
    companyLocations: state.companyLocations,
    jobCategories: state.jobCategories,
    companyDetails: state.companies.companyDetails
  };
};

export default connect(mapStateToProps, {
  searchEmployersAction,
  clearEmployersPredictionsList,
  getAllSkills,
  getSkillLevels,
  getEventsAction,
  getLocationsListAction,
  getAllDressCodesAction,
  editEventAction,
  createEventAction,
  createJobAction,
  createMultiDayJob,
  getPayCostRateAction,
  getDetailedUser,
  clearEmployerDetails,
  getCompanyLocations,
  getAllJobCategories,
  addUserLocation,
  postToBoardAction,
  UIShowAlert,
  UIShowConfirm,
  getCompanyLTAWorkers,
  clearCompanyLTAWorkers,
  getCompanyFavAndBlocks,
  clearCompanyFavAndBlocks,
  addJobWorkerAction,
  hideAsideMenu,
  showAsideMenu,
  getCompanyDetailsAction
})(CreateJobContainer);



// WEBPACK FOOTER //
// ./src/components/app/createJob/CreateJobContainer.js